import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import { StrictUserPermissionKey } from "api/interfaces/userInterface.interface";
import { allSubcriptionPermission } from "pages/users/userGroup/add/PermissionPolicy";
import { useAppSelector } from "redux/hooks";
import { RequiredPermissionType } from "utils/MenuUtil";

type RBACWrapperProps = {
  children: React.ReactNode;
  requiredPermissions: RequiredPermissionType;
  isMenu?: boolean;
};

const RBACWrapper = ({
  requiredPermissions,
  children,
  isMenu = false, //menu 는 hidden 상관없이 보여주기 위함
}: RBACWrapperProps): JSX.Element | null => {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const {
    accountLevel,
    userPermission,
    isHidden,
    cascadedSuspension,
    isEnabled,
  } = selectedAccount;

  const hasRequiredPermissions = () => {
    if (!isMenu && isHidden) {
      return false;
    }
    if (!requiredPermissions || requiredPermissions === "rw") {
      return true;
    }
    if (Array.isArray(requiredPermissions)) {
      if (
        requiredPermissions.some((permission) =>
          allSubcriptionPermission.includes(
            permission as StrictUserPermissionKey
          )
        )
      ) {
        if (accountLevel === LEVEL_TYPE.EU) {
          return userPermission.viewSubscription;
        }
        if (accountLevel === LEVEL_TYPE.CP) {
          return userPermission.manageBillingAndLicenses;
        }
        if (accountLevel === LEVEL_TYPE.DW) {
          const filtered = allSubcriptionPermission.filter(
            (item) =>
              item !== "manageBillingAndLicenses" && item !== "viewSubscription"
          );
          if (filtered.length === 1) {
            return userPermission[filtered[0]];
          }
        }
      }

      return requiredPermissions.some((per) => {
        return userPermission[per as keyof typeof userPermission];
      });
    }

    if (accountLevel === LEVEL_TYPE.EU && !isEnabled) {
      if (requiredPermissions.includes("manageSubscription")) {
        return !cascadedSuspension;
      }
      if (
        requiredPermissions.includes("manage") &&
        requiredPermissions !== "manageRecordersAndGroups"
      ) {
        return false;
      }
      if (requiredPermissions.includes("viewRecordersAndGroups")) {
        return true;
      }
    }

    return userPermission[requiredPermissions as keyof typeof userPermission];
  };
  if (hasRequiredPermissions()) {
    return <>{children}</>;
  }
  return null;
};

export default RBACWrapper;
